<kendo-dropdownlist [data]="data"
                    (valueChange)="onChange($event)"
                    [defaultItem]="defaultItem"
                    [textField]="textField"
                    [valueField]="valueField">
</kendo-dropdownlist>
